(function(){
  var more=document.querySelector('[data-more]');
  if(more)more.addEventListener('click',function(){document.querySelectorAll('.rev--more').forEach(function(r){r.classList.add('show')});more.remove()});
})();

/* ===== product page ===== */
(function(){
  var root=document.querySelector('[data-pp]');if(!root)return;
  var bundle=root.getAttribute('data-bundle-mode')==='true';
  var cfg={gifts:{}};try{cfg=JSON.parse(root.querySelector('[data-cfg]').textContent)}catch(e){}
  var cur=root.getAttribute('data-cur')||'$';
  var money=function(c){return cur+(c/100).toFixed(2)};
  var err=root.querySelector('[data-err]');
  var atcs=[].slice.call(root.querySelectorAll('[data-atc]'));
  var vidIn=root.querySelector('[data-vid-input]');
  var gal=root.querySelector('[data-gal]');
  function goImg(i){if(gal)gal.scrollTo({left:gal.clientWidth*i,behavior:'smooth'})}
  function setPrice(p,c){
    root.querySelector('[data-price]').textContent=money(p);
    root.querySelector('[data-total]').textContent=money(p);
    root.querySelector('[data-sticky-total]').textContent=money(p);
    var s=root.querySelector('[data-compare]'),o=root.querySelector('[data-off]');
    if(s)s.textContent=c>p?money(c):'';
    if(o){if(c>p){o.hidden=false;o.textContent='SAVE '+Math.floor((c-p)*100/c)+'%'}else o.hidden=true}
  }

  var units=1,card=null;
  if(bundle){
    var cards=[].slice.call(root.querySelectorAll('.bc'));
    card=cards.filter(function(c){return c.classList.contains('is-sel')})[0]||cards[0];
    var rows=[].slice.call(root.querySelectorAll('.drow'));
    function render(){
      units=+card.getAttribute('data-units');
      vidIn.value=card.getAttribute('data-vid');
      setPrice(+card.getAttribute('data-price'),+card.getAttribute('data-compare'));
      root.querySelector('[data-sticky-name]').textContent='Buy '+units;
      rows.forEach(function(r){r.hidden=+r.getAttribute('data-row')>units});
    }
    cards.forEach(function(c){c.addEventListener('click',function(){
      cards.forEach(function(x){x.classList.remove('is-sel')});c.classList.add('is-sel');
      c.querySelector('input').checked=true;card=c;render();
    })});
    rows.forEach(function(r){
      var sws=[].slice.call(r.querySelectorAll('.sw')),nm=r.querySelector('[data-dname]');
      sws.forEach(function(s){s.addEventListener('click',function(){
        sws.forEach(function(x){x.classList.remove('on')});s.classList.add('on');
        nm.textContent=s.getAttribute('data-design');
        var i=+s.getAttribute('data-img');if(i>0)goImg(i-1);
      })});
    });
    render();
  }else{
    var vs=[];try{vs=JSON.parse(root.querySelector('[data-variants]').textContent)}catch(e){}
    var sels=[].slice.call(root.querySelectorAll('[data-opt]'));
    function pick(){
      var vals=sels.map(function(s){return s.value});
      var v=vs.filter(function(x){return vals.every(function(val,k){return x.options[k]===val})})[0];
      atcs.forEach(function(b){b.disabled=!v||!v.available});
      if(!v){root.querySelector('[data-total]').textContent='Unavailable';return}
      vidIn.value=v.id;setPrice(v.price,v.compare_at_price||0);
      if(!v.available)root.querySelector('[data-total]').textContent='Sold out';
      if(v.featured_image&&gal){var imgs=[].slice.call(gal.querySelectorAll('img'));imgs.forEach(function(im,k){if(im.currentSrc&&im.currentSrc.split('?')[0].split('/').pop().split('_')[0]===v.featured_image.src.split('?')[0].split('/').pop().split('_')[0])goImg(k)})}
    }
    sels.forEach(function(s){s.addEventListener('change',pick)});
    if(sels.length)pick();
  }

  function add(go){
    var items=[];
    if(bundle){
      var props={};
      [].forEach.call(root.querySelectorAll('.drow'),function(r){
        var n=+r.getAttribute('data-row');if(n>units)return;
        var on=r.querySelector('.sw.on');if(on)props['Ball '+n]=on.getAttribute('data-design');
      });
      items.push({id:+vidIn.value,quantity:1,properties:props});
      if(units>=2&&cfg.gifts.protection)items.push({id:cfg.gifts.protection,quantity:1});
      if(units>=3&&cfg.gifts.mystery)items.push({id:cfg.gifts.mystery,quantity:1});
    }else{
      items.push({id:+vidIn.value,quantity:1});
    }
    atcs.forEach(function(b){b.disabled=true});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
      .then(function(){window.location.href=go?'/checkout':'/cart'})
      .catch(function(){atcs.forEach(function(b){b.disabled=false});err.textContent='Could not add to cart. Please try again.';err.hidden=false});
  }
  atcs.forEach(function(b){b.addEventListener('click',function(){add(false)})});
  root.querySelector('[data-buy]').addEventListener('click',function(){add(true)});

  var dots=[].slice.call(root.querySelectorAll('[data-dots] button')),thumbs=[].slice.call(root.querySelectorAll('.gal__thumb'));
  dots.concat(thumbs).forEach(function(t){t.addEventListener('click',function(){goImg(+t.getAttribute('data-i'))})});
  function mark(){var i=Math.round(gal.scrollLeft/gal.clientWidth);dots.forEach(function(d,k){d.classList.toggle('on',k===i)});thumbs.forEach(function(t,k){t.classList.toggle('on',k===i)})}
  if(gal&&(dots.length||thumbs.length)){gal.addEventListener('scroll',mark,{passive:true});mark()}

  var sticky=root.querySelector('[data-sticky]'),main=root.querySelector('.btn--atc');
  if(sticky&&main&&'IntersectionObserver' in window){new IntersectionObserver(function(e){sticky.classList.toggle('show',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(main)}
})();

/* ===== cart: add-on, upgrades, orphan gift cleanup ===== */
(function(){
  var c=document.querySelector('[data-cart]');if(!c)return;
  function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){if(!r.ok)throw new Error(url);return r.json()})}
  var reload=function(){location.reload()};
  var mainLine=+c.getAttribute('data-main-line');
  var prot=c.getAttribute('data-prot'),mys=c.getAttribute('data-mys');
  var have=(c.getAttribute('data-have')||'').split(',');

  if(!mainLine){
    var gifts=[prot,mys].filter(function(g){return g&&have.indexOf(g)>-1});
    if(gifts.length){var upd={};gifts.forEach(function(g){upd[g]=0});post('/cart/update.js',{updates:upd}).then(reload).catch(function(){})}
  }

  var add=c.querySelector('[data-add-addon]');
  if(add)add.addEventListener('click',function(){add.disabled=true;post('/cart/add.js',{items:[{id:+add.getAttribute('data-vid'),quantity:1}]}).then(reload).catch(function(){add.disabled=false})});

  var props={};try{var raw=JSON.parse(c.querySelector('[data-main-props]').textContent)||{};if(Array.isArray(raw)){raw.forEach(function(p){if(p&&p.length===2)props[p[0]]=p[1]})}else{props=raw}}catch(e){}
  [].forEach.call(c.querySelectorAll('[data-upgrade]'),function(btn){
    btn.addEventListener('click',function(){
      var n=+btn.getAttribute('data-units'),box=btn.closest('.up'),p={};
      Object.keys(props).forEach(function(k){p[k]=props[k]});
      [].forEach.call(box.querySelectorAll('[data-ball]'),function(s){p['Ball '+s.getAttribute('data-ball')]=s.value});
      var items=[{id:+btn.getAttribute('data-vid'),quantity:1,properties:p}];
      if(prot&&have.indexOf(prot)<0)items.push({id:+prot,quantity:1});
      if(n>=3&&mys&&have.indexOf(mys)<0)items.push({id:+mys,quantity:1});
      btn.disabled=true;
      post('/cart/change.js',{line:mainLine,quantity:0}).then(function(){return post('/cart/add.js',{items:items})}).then(reload).catch(function(){btn.disabled=false});
    });
  });
})();

/* ===== star line under the product title, from the reviews section ===== */
(function(){
  function run(){
    var t=document.querySelector('.pp__title'),h=document.querySelector('#reviews .revhead');
    if(!t||!h||document.querySelector('.pp__rating'))return;
    var st=h.querySelector('.stars'),b=h.querySelector('b'),sp=h.querySelector('span:last-child');
    if(!st||!b||!sp)return;
    var a=document.createElement('a');a.className='pp__rating';a.href='#reviews';
    a.innerHTML=st.outerHTML+' <b>'+b.textContent.replace(/\s+/g,'')+'</b> <span>| '+sp.textContent.trim()+'</span>';
    t.insertAdjacentElement('afterend',a);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

/* ===== announcement countdown to a REAL date (hides itself after) ===== */
(function(){
  var a=document.querySelector('[data-ann]');if(!a)return;
  var cd=a.querySelector('[data-ann-cd]'),t=a.querySelector('[data-ann-t]');
  var end=Date.parse(a.getAttribute('data-deadline')||'');
  function p(n){return (n<10?'0':'')+n}
  function tick(){
    var left=end-Date.now();
    if(isNaN(end)||left<=0){cd.hidden=true;return false}
    var s=Math.floor(left/1000),d=Math.floor(s/86400);
    cd.hidden=false;t.textContent=(d>0?d+'d ':'')+p(Math.floor(s%86400/3600))+':'+p(Math.floor(s%3600/60))+':'+p(s%60);return true;
  }
  if(tick())setInterval(tick,1000);
  var slides=[].slice.call(a.querySelectorAll('.ann__slide')),i=0;
  if(slides.length>1)setInterval(function(){slides[i].classList.remove('is-on');i=(i+1)%slides.length;slides[i].classList.add('is-on')},3800);
})();
